import type { ProfitabilityDataPoint } from "../../components/profitability-chart";

export const profitabilityMeasures = ["Profit", "Sales", "SalesIncReturns", "Marketing", "ROAS", "AOV", "CAC"] as const;
export type ProfitabilityMeasure = (typeof profitabilityMeasures)[number];
export type ProfitabilityPeriod = "thisYears" | "lastYears";

export const profitabilityValues = (
  rows: ProfitabilityDataPoint[],
  measure: ProfitabilityMeasure,
  period: ProfitabilityPeriod
) =>
  rows.map((datum) => ({
    category: datum.dayRaw ?? datum.day,
    y: datum[`${period}${measure}Value`] ?? null,
    datum,
  }));

export const periodMovement = (row: ProfitabilityDataPoint, measure: ProfitabilityMeasure, current: number) => {
  const previous: number | null = row[`thisYears${measure}PreviousValue`];
  if (previous == null || previous === 0) {
    return null;
  }
  const movement = (100 * (current - previous)) / Math.abs(previous);
  return Number.isFinite(movement) ? movement : null;
};
